module.exports = __webpack_public_path__ + "static/media/orange_logo.dd5c4d43.png";